/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import FormInput from "../../../components/forms/form-Input";
import { replenishmentModelsDefault, denominationDefault } from "../constants";
import { useLookupCurrencyMultiples } from "../../../services/lookups-mutations";

export default function ReplenishmentModels({
  onPrevStep,
  onNextStep,
  currencies,
  models,
  addData,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [currentEditingDeno, setCurrentEditingDeno] = useState(null);
  const {
    mutate: getMultiples,
    data: multipleList,
    reset: resetMultiples,
  } = useLookupCurrencyMultiples();

  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    clearErrors,
    reset,
    watch,
    formState: { errors },
    trigger,
  } = useForm({
    defaultValues: { ...replenishmentModelsDefault, models: [...models] },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    code: { required: "Please Enter Code" },
    currency: { required: "Please Select Currency" },
    multiple: { required: "Please Select Multiple" },
    noOfCassettes: {
      required: "Please Enter Cassettes",
      validate: (value) => {
        if (!value || value === "0") return "Please Enter Cassettes";
        return true;
      },
    },
    noOfNotes: {
      required: "Please Enter Notes",
      validate: (value) => {
        if (!value || value === "0") return "Please Enter Notes";
        return true;
      },
    },
  };
  const { fields: denominationFields, remove: denominationRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "denominations",
    });
  const {
    fields: modelFields,
    remove: modelRemove,
    update: modelUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "models",
  });
  useEffect(() => {
    if (addData) addData([...modelFields]);
  }, [modelFields]);
  useEffect(() => {
    const _currency = watch("currency");
    resetMultiples();
    if (_currency) {
      getMultiples(_currency.shortName);
    }
  }, [watch("currency")]);

  const submitInfo = async () => {
    const _data = { ...getValues() };
    const isCodeValid = await trigger("code");
    if (!isCodeValid) return;

    const _fields = [...modelFields];
    const modelObj = {
      code: _data.code,
      denominations: _data.denominations,
      expanded: false,
    };

    if (currentEditing !== null) {
      _fields[currentEditing] = { ...modelObj };
      setCurrentEditing(null);
    } else {
      _fields.push({ ...modelObj });
    }
    reset({ ...replenishmentModelsDefault, models: _fields });
  };

  const cancelEditing = () => {
    setCurrentEditing(null);
    const _fields = [...modelFields];
    reset({ ...replenishmentModelsDefault, models: _fields });
  };

  const addDenomination = async () => {
    const _denominations = [...denominationFields];
    const newItem = {
      currency: getValues("currency"),
      multiple: getValues("multiple"),
      noOfCassettes: getValues("noOfCassettes"),
      noOfNotes: getValues("noOfNotes"),
    };

    if (currentEditingDeno === null) {
      _denominations.push(newItem);
    } else {
      _denominations[currentEditingDeno] = newItem;
      setCurrentEditingDeno(null);
    }
    const _models = [...modelFields];
    reset({
      ...replenishmentModelsDefault,
      code: getValues("code"),
      denominations: _denominations,
      models: _models,
    });
    if (errors.denominations) {
      clearErrors("denominations");
    }
  };

  const onCurrencyChange = () => {
    setValue("multiples", "");
  };

  const editDenominationCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            const _models = [...modelFields];
            const _denominations = [...denominationFields];
            reset({
              code: getValues("code"),
              ...dataItem,
              models: _models,
              denominations: _denominations,
            });
            setCurrentEditingDeno(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteDenominationCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete "
          cursor="pointer"
          onClick={() => {
            denominationRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelDenominationEditing = () => {
    reset({ ...getValues(), ...denominationDefault });
    setCurrentEditingDeno(null);
  };
  const editModelCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            reset({
              ...replenishmentModelsDefault,
              ...dataItem,
              models: [...modelFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteModelCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete"
          cursor="pointer"
          onClick={() => {
            modelRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const expandChange = ({ dataIndex }) => {
    const _models = [...modelFields];
    _models[dataIndex].expanded = !_models[dataIndex].expanded;
    modelUpdate(dataIndex, _models[dataIndex]);
  };

  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Denominations
        </Heading>
        <Grid data={dataItem.denominations}>
          <GridColumn
            title="Currency"
            cell={({ dataItem }) => (
              <td>
                {dataItem.currency.shortName}&nbsp;{dataItem.multiple.text}
              </td>
            )}
          />
          <GridColumn title="Cassettes" field="noOfCassettes" />
          <GridColumn title="Notes" field="noOfNotes" />
        </Grid>
      </>
    );
  }

  return (
    <form onSubmit={handleSubmit(addDenomination)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Replenishment Models</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button onClick={() => onPrevStep(modelFields)}>Back</Button>
            <Button onClick={() => onNextStep(modelFields)}>Next</Button>
          </Flex>
        </Flex>
      </Flex>
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Code"
        rules={formValidationRules.code}
        name="code"
      />

      <Heading
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      >
        Denominations
      </Heading>

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        id="shortName"
        text="name"
        data={currencies || []}
        placeholder="Select Currency"
        rules={formValidationRules.currency}
        onChange={onCurrencyChange}
        dropdownProps={{ filterable: true }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Multiples"
        name="multiple"
        id="id"
        text="text"
        data={
          multipleList?.data.map((elm) => ({
            id: elm.multiple,
            text: elm.multiple,
          })) || []
        }
        placeholder="Select Multiple"
        rules={formValidationRules.multiple}
        dropdownProps={{ filterable: true }}
        disabled={!watch("currency")}
      />

      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Cassettes"
        rules={formValidationRules.noOfCassettes}
        name="noOfCassettes"
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Notes"
        rules={formValidationRules.noOfNotes}
        name="noOfNotes"
      />

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditingDeno !== null ? (
          <Button onClick={cancelDenominationEditing}>Cancel</Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditingDeno !== null
            ? "Update Denomination"
            : "Add Denomination"}
        </Button>
      </div>

      <Grid data={denominationFields}>
        <GridColumn
          title="Currency"
          cell={({ dataItem }) => (
            <td>
              {dataItem.currency.shortName}&nbsp;{dataItem.multiple.text}
            </td>
          )}
        />
        <GridColumn title="Cassettes" field="noOfCassettes" />
        <GridColumn title="Notes" field="noOfNotes" />
        <GridColumn title="Edit" width={100} cell={editDenominationCell} />
        <GridColumn title="Delete" width={100} cell={deleteDenominationCell} />
      </Grid>
      <div
        style={{
          width: "100%",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: "4px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: "16px" }}>
          {currentEditing !== null ? (
            <Button
              onClick={cancelEditing}
              disabled={denominationFields.length === 0}
              style={{ width: "fit-content" }}
            >
              Cancel
            </Button>
          ) : (
            <></>
          )}
          <Button
            onClick={submitInfo}
            disabled={denominationFields.length === 0}
            style={{ width: "flex-end" }}
          >
            {currentEditing !== null ? "Update Model" : "Add Model"}
          </Button>
        </div>

        {denominationFields.length === 0 ? (
          <p
            className="error-message"
            style={{ color: "black", textAlign: "right" }}
          >
            Please Add At least One Denomination To Enable
          </p>
        ) : (
          <></>
        )}
      </div>
      <Grid
        data={modelFields}
        detail={DetailComponent}
        expandField="expanded"
        onExpandChange={expandChange}
      >
        <GridColumn title="Code" field="code" />
        <GridColumn title="Edit" width={100} cell={editModelCell} />
        <GridColumn title="Delete" width={100} cell={deleteModelCell} />
      </Grid>
    </form>
  );
}
